import { Avatar, Icon, Pressable, Stack, Text } from "../../primitives/index.ts";

export type HuddleChipProps = {
  /** Up to three faces of people in the huddle. */
  faces: { name: string; src?: string; square?: boolean }[];
  /** "Join" when I'm not in it; my status ("In huddle") when I am. */
  label: string;
  joined: boolean;
  accessibilityLabel: string;
  onPress: () => void;
  testID: string;
};

/** A conversation's live huddle in its header: faces + Join (or "you're in it"). */
export function HuddleChip(p: HuddleChipProps) {
  return (
    <Pressable direction="horizontal" radius="full" onPress={p.onPress} accessibilityLabel={p.accessibilityLabel} testID={p.testID}>
      <Stack direction="horizontal" align="center" gap="1.5" paddingX="2" paddingY="0.5" radius="full" background={p.joined ? "chip.bg" : "accent.subtle"} border="status.success">
        <Icon name="huddle" size="icon.sm" color="status.success" />
        <Stack direction="horizontal" align="center">
          {p.faces.slice(0, 3).map((f, i) => (
            <Avatar key={`${f.name}-${i}`} name={f.name} src={f.src} square={f.square} size="avatar.xs" />
          ))}
        </Stack>
        <Text variant="footnote" weight="semibold" color={p.joined ? "text.secondary" : "text.primary"}>
          {p.label}
        </Text>
      </Stack>
    </Pressable>
  );
}
